// src/redux/store.ts
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import providerSearchReducer from './slices/providerSearchSlice';
import rootSaga from './sagas';
import headerReducer from './slices/headerSlice';

// Create saga middleware
const sagaMiddleware = createSagaMiddleware();

// Configure store with middleware
const store = configureStore({
  reducer: {
    providerSearch: providerSearchReducer,
    header: headerReducer, // Add this line to register the header reducer
    // Add other reducers here
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});

// Run the root saga - THIS IS CRITICAL
try {
  sagaMiddleware.run(rootSaga);
} catch (error) {
  console.error('Failed to start root saga:', error);
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;